import React from "react";
import { Menu, MenuItem } from "@mui/material";
import { isBundleListing } from "../utils/helpers";

export const ListingActionsMenu = ({
  anchorEl,
  open,
  onClose,
  item,
  onPublish,
  onUnpublish,
  onRequestUnblock,
  onEnableSharableLink,
  onDisableSharableLink,
  showMoveToFolder = false,
  onMoveToFolderClick,
  onEdit,
}) => {
  const isBundle = isBundleListing(item);

  const handleMoveToFolderClick = () => {
    if (onMoveToFolderClick && item?.id) onMoveToFolderClick(item.id, isBundle);
    onClose();
  };

  const handleEditClick = () => {
    if (onEdit && item) onEdit(item);
    onClose();
  };

  const handlePublishClick = () => {
    onPublish(item?.id, "true", undefined, item, undefined, undefined);
    onClose();
  };

  const handleUnpublishClick = () => {
    onUnpublish(item?.id, "false", undefined, item, undefined, undefined);
    onClose();
  };

  const handleRequestUnblockClick = () => {
    onRequestUnblock(item?.id, undefined, true, item, undefined, undefined);
    onClose();
  };

  const handleEnableSharableLinkClick = () => {
    onEnableSharableLink(item?.id, undefined, false, item, true, false);
    onClose();
  };

  const handleDisableSharableLinkClick = () => {
    onDisableSharableLink(item?.id, undefined, false, item, true, true);
    onClose();
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
    >
      {onEdit && (
        <MenuItem onClick={handleEditClick}>Edit</MenuItem>
      )}
      {showMoveToFolder && onMoveToFolderClick && (
        <MenuItem onClick={handleMoveToFolderClick}>
          {item?.shop_folder ? "Move to another folder" : "Move to folder"}
        </MenuItem>
      )}
      {item?.is_blocked ? (
        <>
          <MenuItem onClick={handleRequestUnblockClick}>
            Request Unblock
          </MenuItem>
          {!isBundle && (
            <>
              {item?.sharable_link_enabled ? (
                <MenuItem onClick={handleDisableSharableLinkClick}>
                  Disable Sharable Link
                </MenuItem>
              ) : (
                <MenuItem onClick={handleEnableSharableLinkClick}>
                  Enable Sharable Link
                </MenuItem>
              )}
            </>
          )}
        </>
      ) : item?.is_published ? (
        <>
          <MenuItem onClick={handleUnpublishClick}>Unpublish</MenuItem>
          {!isBundle && (
            <>
              {item?.sharable_link_enabled ? (
                <MenuItem onClick={handleDisableSharableLinkClick}>
                  Disable Sharable Link
                </MenuItem>
              ) : (
                <MenuItem onClick={handleEnableSharableLinkClick}>
                  Enable Sharable Link
                </MenuItem>
              )}
            </>
          )}
        </>
      ) : (
        <>
          <MenuItem onClick={handlePublishClick}>Publish</MenuItem>
          {!isBundle && (
            <>
              {item?.sharable_link_enabled ? (
                <MenuItem onClick={handleDisableSharableLinkClick}>
                  Disable Sharable Link
                </MenuItem>
              ) : (
                <MenuItem onClick={handleEnableSharableLinkClick}>
                  Enable Sharable Link
                </MenuItem>
              )}
            </>
          )}
        </>
      )}
    </Menu>
  );
};

